// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"popUp_backdrop__12M4B","popUp":"popUp_popUp__N7u9N","wrapper":"popUp_wrapper__1sL78"};